export enum ServiceTypes {
	Private = 'private',
	Shared = 'shared',
}